module.exports = __webpack_public_path__ + "7aba396ddb14e91ea4dc77ff8b41a270.svg";